// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__q-8De","col":"Table_col__1-XZP","fulfillmentStatus":"Table_fulfillmentStatus__Ka_OY","emailCol":"Table_emailCol__3jkhd"};